import React from 'react';
import SidenavContent from './SidenavContent';
import PropTypes from "prop-types";
import Framework from '@beardeddevops/react.framework';

class Sidebar extends React.Component {
	static propTypes = {
		locations: PropTypes.array,
		reloadShell: PropTypes.func.isRequired
	};

	render() {
		return (
			<Framework.Components.SideBar
				rootState={this.props.rootState}
				footerLink={"https://fflsoftwarepro.freshdesk.com/"}
				clickOutside={false}
				{...this.props}>
				<SidenavContent {...this.props} />
			</Framework.Components.SideBar>
		);
	}
}

export default Sidebar = Framework.Components.withRootState(Sidebar);

